import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { translate } from 'react-i18next';

const enhance = compose(translate(['geozones'], { wait: true }));

export const GeozoneAddItem = enhance(({ onAddClick, t }) =>
  (<li className="garage-list__item">
    <div className="garage-region">
      <div className="garage-region__map" />
      <div className="garage-region__content">
        <div className="garage-region__description">
          <h3 className="garage-region__title">{t('geozones:new-geozone__title')}</h3>
          <p className="text">{t('geozones:new-geozone__description')}</p>
        </div>
        <footer className="garage-region__action">
          <a role="presentation" onClick={onAddClick} className="link link_action_add">{t('geozones:new-geozone__add')}</a>
        </footer>
      </div>
    </div>
  </li>),
);

GeozoneAddItem.WrappedComponent.propTypes = {
  t: PropTypes.func.isRequired,
  onAddClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Modal/SettingsModal/Geozones/GeozoneAddItem.js